/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";
import { formatMoneyPunto, makeNiceText } from "utils/formatters";

const getRows = (data, handleAction) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            data={
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color: getColor("gobPrimary"),
                }}
                fontSize="lg"
              >
                {item.tipo === "Permiso de pesca anual" ? "calendar_month" : "event"}
              </Icon>
            }
            onClick={(e) => handleAction(item)}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title={item?.tipo} placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: getColor("gobPrimary"),
                  }}
                  fontSize="lg"
                >
                  {item.tipo === "Permiso de pesca anual" ? "calendar_month" : "event"}
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={`${item?.anioPermiso} - ${item?.nroPermiso}`}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {`${item?.anioPermiso} - ${item?.nroPermiso}`}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={`${item?.estado}`}
            onClick={(e) => handleAction(item)}
          >
            <SoftBadge
              color={
                item.estado === "Aprobado"
                  ? "success"
                  : item.estado === "Rechazado"
                  ? "error"
                  : item.estado === "En revisión"
                  ? "gobSecondary"
                  : "primary"
              }
              badgeContent={item.estado}
            />
          </SoftBox>
        ),
        solicitante: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={
              item?.usuario?.apellido
                ? makeNiceText(item?.usuario?.apellido + " " + item?.usuario?.nombre, "nombre")
                : item?.usuario?.username
            }
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {makeNiceText(item?.usuario?.apellido + " " + item?.usuario?.nombre, "nombre")}
            </SoftTypography>
          </SoftBox>
        ),
        dni: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={formatMoneyPunto(item?.usuario?.dni)}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {formatMoneyPunto(item?.usuario?.dni)}
            </SoftTypography>
          </SoftBox>
        ),
        email: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="medium"
            >
              {item?.usuario?.email}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleAction(item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: getColor("gobSecondary"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleAction(item)}
              >
                arrow_forward
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", width: "100px", align: "left" },
  { name: "solicitante", desc: "Solicitante", align: "left", orderField: "idUser" },
  { name: "estado", desc: "Estado", align: "left" },
  { name: "dni", desc: "DNI", align: "left" },
  { name: "email", desc: "Email", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
